// Helper to normalize any YouTube URL into an /embed/ URL.
export function toEmbedUrl(url) {
  if (!url) return '';
  const u = String(url).trim();
  if (!u) return '';
  if (u.includes('/embed/')) return u;
  // youtu.be/<id>
  const short = u.match(/youtu\.be\/([\w-]{6,})/);
  if (short) return `https://www.youtube.com/embed/${short[1]}`;
  // youtube.com/watch?v=<id>
  try {
    const parsed = new URL(u);
    const v = parsed.searchParams.get('v');
    if (v) return `https://www.youtube.com/embed/${v}`;
  } catch (e) { /* not a URL */ }
  // youtube.com/shorts/<id>
  const shorts = u.match(/youtube\.com\/shorts\/([\w-]{6,})/);
  if (shorts) return `https://www.youtube.com/embed/${shorts[1]}`;
  // last resort: treat as already-embed-friendly
  return u;
}
